<template>
  <div class="col-md-4 container recent-blogs">
    <h6 class="recent-blog__title mb-4">RECENT BLOGS</h6>
    <div v-for="(blog, index) in blogs" :key="'blog' + index">
      <div
        v-if="blog"
        class="recent-blog__card"
        @click="

            $router.push({
              path: `/aliff-blogs-recent/bg/${blog.bg_id}/${convertToSlug(blog.bg_title)}`,
            })
        "
      >
        <div v-if="blog.bg_image_one">
          <img
            :src="`${IMAGEURL}${blog.bg_image_one}`"
            class="img-fluid blog-img-1"
          />
        </div>
        <p class="recent-blog__sub-title">{{ blog.bg_title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { IMAGEURL } from "@/config/index";
import { mapGetters } from "vuex";
import homeServices from "@/apiServices/homeServices";

export default {
  computed: {
    ...mapGetters(["getBlogs"]),
  },
  data() {
    return {
      IMAGEURL,
      // id: 2,
    };
  },
  props: {
    blogs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    convertToSlug(title) {
      return title.toLowerCase().replace(/\s+/g, "-");
    },
    // async getBlogById() {
    //   try {
    //     const response = await homeServices.getSingleBlog({ bg_id: blog.bg_id });
    //     if (response.data.status) {
          
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },

  beforeMount() {
    this.getBlogById();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/RecentBlogs.vue